/**
 * Quick View Trigger component
 * 
 * @module component-quickview-trigger
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-quickview-trigger';

if(!customElements.get(customElements.component)) {

    class quickViewTrigger extends HTMLElement {

        /**
         * Quick view trigger web component
         * 
         * @constructor
         */
        constructor() {
            super();

            if (this.dataset.handle) {

                this.initEvents();

            } else {

                console.log('Quick view trigger missing handle', this);
            }
        }

        /**
         * Init component events.
         * 
         * @returns {undefined}
         */
        initEvents() {

            let trigger = this.getElementTrigger();

            if (trigger) {

                trigger.addEventListener('click', event => {
                    event.preventDefault();
                    const handle = this.dataset.handle;
                    const variantId = this.dataset.variantId;
                    if (variantId) {
                        window.theme.quickView.open(handle, variantId);
                    } else {
                        window.theme.quickView.open(handle);
                    }
                });
            }
        }

        /**
         * Get trigger element.
         * 
         * @returns {object} Trigger element.
         */
        getElementTrigger() {

            let trigger = this.querySelector('[data-quickview-trigger]');

            if (!trigger) {
                trigger = this.querySelector('button');
            }

            return trigger;
        }
    }

    customElements.define(customElements.component, quickViewTrigger);
}
